import { useAssistantChatSettingsQuery } from '@/entities/ai-assistant'

import { AssistantChatLauncher } from './AssistantChatLauncher'

export default function AssistantChat() {
	const { data } = useAssistantChatSettingsQuery()
	if (!data?.is_enabled) {
		return null
	}

	return <AssistantChatLauncher />
}
